"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RtbBlock = require("./RtbBlock");
var _CardContentBlock = require("./CardContentBlock");
// Built In Components For Card.

const Card = ({
  rtbProps = {},
  dataCy = 'cardFromSiteLibrary',
  cardContentProps = {},
  customComponents = {},
  cardBlockClassName = ''
}) => {
  const {
    CustomCardContentBlock,
    CustomRtbBlock
  } = customComponents;
  const CardContentBlock = CustomCardContentBlock ? CustomCardContentBlock : _CardContentBlock.CardContentBlock;
  const RtbBlock = CustomRtbBlock ? CustomRtbBlock : _RtbBlock.RtbBlock;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": dataCy,
    "data-testid": "card",
    className: cardBlockClassName
  }, /*#__PURE__*/_react.default.createElement(CardContentBlock, (0, _CardContentBlock.getCardContentProps)(cardContentProps)), /*#__PURE__*/_react.default.createElement(RtbBlock, (0, _RtbBlock.getRtbProps)(rtbProps)));
};
exports.Card = Card;
Card.propTypes = {
  dataCy: _propTypes.default.string,
  // Override default className for most outer block of CardBlock component.
  cardBlockClassName: _propTypes.default.string,
  // Use RenderProps for each section of the CardBlock, and don't use Built-In Components.
  customComponents: _propTypes.default.shape({
    CustomRtbBlock: _propTypes.default.func,
    CustomCardContentBlock: _propTypes.default.func
  }),
  // Use Our Built-In Components, but pass in specific props.
  rtbProps: _propTypes.default.shape(_RtbBlock.RtbBlock.propTypes),
  cardContentProps: _propTypes.default.shape(_CardContentBlock.CardContentBlock.propTypes)
};